import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import ReactHighcharts from 'react-highcharts';
import {tntGreen, tntFadedGreen, tntFadedRed, tntRed} from '../../theme/tntColors';
import {grey200, darkBlack} from 'material-ui/styles/colors';

const styles = {
  wrapper: {
    padding: 15
  },
};

class NpsGauge extends Component {
  render() {
    let chartHeight = this.props.height-(styles.wrapper.padding*2);
    let chartWidth = this.props.width-(styles.wrapper.padding*2);

    const chartConfig = {
      chart: {
        type: 'solidgauge',
        // Highcharts throws an error if the container is too small
        height: chartHeight >= 50 ? chartHeight : 50,
        width: chartWidth >= 50 ? chartWidth : 50,
      },
      title: null,
      tooltip: {
        enabled: false,
      },
      pane: {
        center: ['50%', '90%'],
        size: '160%',
        startAngle: -60,
        endAngle: 60,
        background: {
          backgroundColor: grey200,
          borderColor: grey200,
          innerRadius: '60%',
          outerRadius: '100%',
          shape: 'arc',
        }
      },
      yAxis: {
        stops: [
          [0.25, tntRed],
          [0.5, tntFadedRed],
          [0.75, tntFadedGreen],
          [1, tntGreen],
        ],
        minorTickInterval: null,
        tickAmount: 0,
        tickWidth: 0,
        lineWidth: 0,
        labels: {
          y: 22,
          distance: -15,
          style: {
            fontSize: '15px',
            fontWeight: 'bold',
            color: 'silver',
          },
        },
        min: -100,
        max: 100,
      },
      plotOptions: {
        solidgauge: {
          dataLabels: {
            y: 5,
            borderWidth: 0,
            useHTML: true,
            format: 
              '<div style="text-align:center">' + 
                '<span style="font-size:25px;color:' + darkBlack + '">' + 
                  '{y:.0f}' +
                '</span>' +
                '<br/>' + 
                '<span style="font-size:12px;color:silver">NPS</span>' +
              '</div>'
          },
        },
      },
      series: [{
        data: [this.props.answersReport.nps],
      }],
    };

    return (
      <div style={styles.wrapper}>
        <ReactHighcharts 
          config={chartConfig}
          domProps={{id: this.props.uniqueId}}
        />
      </div>
    );
  }
}

export default createFragmentContainer(
  NpsGauge,
  graphql`
    fragment NpsGauge_answersReport on AnswersReport {
      nps
    }
  `,
);



// WEBPACK FOOTER //
// ./src/components/NpsGauge/NpsGauge.js